(ns ui.components.icon.view
  (:require
   [ui.util :as uu]))

(defn clickable
  [{:keys [disabled? on-click tooltip ref]} & children]
  (into
   [:div
    {:on-click (fn [e]
                 (when (and (fn? on-click)
                            (not disabled?))
                   (on-click e)))
     :ref      ref
     :class (uu/cm "w-6 h-6 flex items-center justify-center rounded"
                   "border-0 cursor-pointer"
                   (when disabled?
                     "text-base-light-text"))
     :title    tooltip}]
   children))
